//load our custom elements
require("component-leaflet-map");
require("component-responsive-frame");
require("leaflet.sync")



//get access to Leaflet and the map
var element = document.querySelector("leaflet-map.voters");
var L = element.leaflet;
var mapvoters = element.map;

//ICH code for popup template if needed----------
var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);

 //map sync
var center = [47.604575, -122.334715];
var layer1 = L.tileLayer('http://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
  });
var layer2 = L.tileLayer('http://a.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png', {
  });
var map1 = L.map('map1', {
            layers: [layer1],
            center: center,
            zoom: 10
        });
map1.attributionControl.setPrefix('');
var map2 = L.map('map2', {
            layers: [layer2],
            center: center,
            zoom: 10,
        });
map1.sync(map2);
map2.sync(map1);


//map 1

var data = require("./registered.geo.json");
var mapElementVoters = document.querySelector("leaflet-map.voters");


var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");

data.features.forEach(function(f) {
  ["Registered"].forEach(function(prop) {
    f.properties[prop] = commafy(f.properties[prop]);
  });
});
var all = "Registered";

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
  // layer.on({
  // 	     mouseover: function(e) {
  //       layer.setStyle({ weight: 2.5, fillOpacity: 1 });
  //     },
  //     mouseout: function(e) {
  //       if (focused && focused == layer) { return }
  //       layer.setStyle({ weight: 1.5, fillOpacity: 0.8
  //        });
  //     }
  //   });
};
var getColor = function(d) {
    var value = d[all];
    if (typeof value == "string") {
      value = Number(value.replace(/,/, ""));
    }
    // console.log(value)
    if (typeof value != "undefined") {
      // condition ? if-true : if-false;
     return value >= 7001 ? '#00306b' :
     		value >= 5501 ? '#0067b9' :
     		value >= 4001 ? '#5391cd' :
        value >= 2501 ? '#91b4dd' :
        value >= 1000 ? '#cbd6eb' :
             '#f1f2f2' ;
    } else {
      return "gray"
    }
  };

  var style = function(feature) {
    var s = {
      fillColor: getColor(feature.properties),
      weight: 1.5,
      opacity: .1,
      color: '#000',
      fillOpacity: 0.8
    };
    return s;
  }

  var geojson = L.geoJson(data, {
    style: style,
    onEachFeature: onEachFeature
  }).addTo(map1);

 map1.scrollWheelZoom.disable();

//map 2

var element = document.querySelector("leaflet-map.turnout");
var L2 = element.leaflet;
var mapTurnout = element.map;

var dataTurnout = require("./turnout.geo.json");
var mapElementTurnout = document.querySelector("leaflet-map.turnout");

dataTurnout.features.forEach(function(f) {
  ["votdst"].forEach(function(prop) {
    f.properties[prop] = commafy(f.properties[prop]);
  });
});

dataTurnout.features.forEach(function(f) {
  ["PERC"].forEach(function(prop) {
    f.properties[prop] = (f.properties[prop] * 1).toFixed(1);
  });
});

var perc = "PERC";

var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
  // layer.on({
  // 	     mouseover: function(e) {
  //       layer.setStyle({ weight: 2.5, fillOpacity: 1 });
  //     },
  //     mouseout: function(e) {
  //       if (focused && focused == layer) { return }
  //       layer.setStyle({ weight: 1.5, fillOpacity: 0.8
  //        });
  //     }
  //   });
};
var getColor = function(d) {
    var value = d[perc];
    if (typeof value == "string") {
      value = Number(value.replace(/,/, ""));
    }
    // console.log(value)
    if (typeof value != "undefined") {
      // condition ? if-true : if-false;
     return value >= 76 ? '#391279' :
     		value >= 75 ? '#593f99' :
     		value >= 60 ? '#7272b6' :
        value >= 45 ? '#a8a8d1' :
        value >= 30 ? '#cecfe6' :
             '#f1f2f2' ;
    } else {
      return "gray"
    }
  };

  var style = function(feature) {
    var s = {
      fillColor: getColor(feature.properties),
      weight: 1.5,
      opacity: .1,
      color: '#000',
      fillOpacity: 0.9
    };
    return s;
  }

  var geojson = L.geoJson(dataTurnout, {
    style: style,
    onEachFeature: onEachFeature
  }).addTo(map2);

 map2.scrollWheelZoom.disable();
